import { cn } from '@nudool/design-system';

type NudoolLogoProps = Readonly<{
  showWordmark?: boolean;
  className?: string;
}>;

export function NudoolLogo({ showWordmark = true, className }: NudoolLogoProps) {
  return (
    <div
      className={cn('flex min-w-0 items-center gap-2', className)}
      {...(!showWordmark ? { role: 'img', 'aria-label': 'Nudool' } : {})}
    >
      <div
        aria-hidden
        className="flex size-7 shrink-0 items-center justify-center rounded-md bg-foreground text-background"
      >
        <span className="text-sm font-semibold leading-none">N</span>
      </div>
      {showWordmark ? (
        <span className="truncate text-sm font-semibold tracking-tight text-foreground">
          Nudool
        </span>
      ) : null}
    </div>
  );
}
